import { useLocation } from 'react-router-dom';
import { redirect } from '~/constants';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { bulkCreateDraftsArrivalPath, isBulkCreateDraftsArrival } from '~/utils/requestAccessLink';
export const useOAuthReturnTo = (returnToProp)=>{
    var _ref;
    const { search } = useLocation();
    const { BULK_CREATE_PROPOSALS } = useFeatureFlags();
    const searchReturnTo = redirect.getReturnToFromSearch(search);
    // WHY: Xero and Intuit log in on their own site, so without this the user returns to /home and the website's link is lost
    const arrivalReturnTo = BULK_CREATE_PROPOSALS && isBulkCreateDraftsArrival(search) ? bulkCreateDraftsArrivalPath(search) : null;
    return (_ref = returnToProp !== null && returnToProp !== void 0 ? returnToProp : searchReturnTo) !== null && _ref !== void 0 ? _ref : arrivalReturnTo;
};
